export default "__VITE_ASSET__D9Eo0atU__"